import { ColDef } from '@ag-grid-community/core';

import { formatDecimal, formatEmpty, formatNumber } from '@util/general/grid.util';

export const defaultColDef = {
  editable: false,
  resizable: true,
  sortable: true,
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: true,
    resetButton: true,
  },
};

export const columnDefs: ColDef[] = [
  { headerName: 'Item', field: 'item', pinned: 'left', cellStyle: { textAlign: 'center' } },
  { headerName: 'Alias', field: 'alias', cellStyle: { textAlign: 'center' } },
  { headerName: 'Description', field: 'descr', cellStyle: { textAlign: 'center' } },
  {
    headerName: 'Product Group',
    field: 'productgroup',
    valueFormatter: (params: any) => formatEmpty(params.value),
    cellStyle: { textAlign: 'center' },
  },
  { headerName: 'Facility', field: 'facility', cellStyle: { textAlign: 'center' } },
  { headerName: 'Customer', field: 'custid', cellStyle: { textAlign: 'center' } },
  {
    headerName: 'Total',
    field: 'qtytotal',
    valueFormatter: (params: any) => formatNumber(params.value),
    type: 'numericColumn',
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Available',
    field: 'qtyalloc',
    valueFormatter: (params: any) => formatNumber(params.value),
    type: 'numericColumn',
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Back Ordered',
    field: 'qtybackorder',
    valueFormatter: (params: any) => formatNumber(params.value),
    type: 'numericColumn',
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Total Weight LBS',
    field: 'totalweight_lbs',
    valueFormatter: (params: any) => formatDecimal(params.value),
    type: 'numericColumn',
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Total Weight KG',
    field: 'totalweight_kgs',
    valueFormatter: (params: any) => formatDecimal(params.value),
    type: 'numericColumn',
    cellStyle: { textAlign: 'right' },
  },
  { headerName: 'Base UOM', field: 'baseuom', cellStyle: { textAlign: 'center' } },
];

export const defColumnPreferences = [
  { colId: 'item', hide: false, aggFunc: null, width: 195, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'alias', hide: false, aggFunc: null, width: 195, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'descr', hide: false, aggFunc: null, width: 250, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'productgroup',
    hide: false,
    aggFunc: null,
    width: 150,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'facility', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'custid', hide: false, aggFunc: null, width: 130, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtytotal', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'qtyalloc', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  {
    colId: 'qtybackorder',
    hide: false,
    aggFunc: null,
    width: 120,
    pivotIndex: null,
    pinned: null,
    rowGroupIndex: null,
  },
  { colId: 'totalweight_lbs', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'totalweight_kgs', hide: false, aggFunc: null, width: 110, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'baseuom', hide: false, aggFunc: null, width: 50, pivotIndex: null, pinned: null, rowGroupIndex: null },
];
